import { errorMessages } from '@/util/helpers'
import {
  fetchLinkedAppointmentTypes,
  fetchChecklists,
  fetchAppointmentTypes,
  linkAppointmentTypeChecklist,
  unlinkAppointmentTypeChecklist,
} from '@/views/appointmentTypeChecklist/service/appointmentTypeChecklistService'
import Vue from 'vue'

const state = {
  linkedServiceTypes: [],
  checklists: [],
  filteredAppointmentTypes: [],
  total: 0,
  search: '',
}

const getters = {
  linkedServiceTypes: (state) => state.linkedServiceTypes,
  checklists: (state) => state.checklists,
  filteredAppointmentTypes: (state) => state.filteredAppointmentTypes,
  total: (state) => state.total,
  search: (state) => state.search,
  options: (state) => state.options,
}

const mutations = {
  setLinkedServiceTypes(state, linkedServiceTypes) {
    state.linkedServiceTypes = linkedServiceTypes
  },
  setChecklists(state, checklists) {
    state.checklists = checklists
  },
  setAppointmentTypes(state, types) {
    state.filteredAppointmentTypes = types
  },
  setTotal(state, total) {
    state.total = total
  },
  setSearch(state, search) {
    state.search = search
  },
  setOptions(state, options) {
    state.options = { ...state.options, ...options }
  },
}

const actions = {
  async fetchLinkedServiceTypes({ commit, dispatch, rootState }, filters = {}) {
    commit('loading/setIsLoading', true, { root: true })
    try {

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }
      const { data } = await fetchLinkedAppointmentTypes(params)
      const {  result, total } = await data
      commit('setLinkedServiceTypes', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('loading/setIsLoading', false, { root: true })
    }
  },

  async linkServiceType({ commit, dispatch }, payload) {
    commit('loading/setIsLoading', true, { root: true })
    try {
      await linkAppointmentTypeChecklist(payload)
      dispatch('fetchLinkedServiceTypes')
      dispatch('showSuccessMessage', Vue.i18n.translate('userChecklistModal.successfullyUpdated'))
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('loading/setIsLoading', false, { root: true })
    }
  },

  async loadChecklists({ commit, dispatch }, params = {}) {
    commit('loading/setIsLoading', true, { root: true })
    try {
      const query = {
        page: params.page ?? 1,
        size: params.size ?? 25,
        hasCode: true,
        ...(params.search && String(params.search).trim()
        ? { search: params.search.trim() }
        : {}),
    }

    const { data } = await fetchChecklists(query)
    const { result, total } = data || {}
    const onlyWithCode = Array.isArray(result) ? result.filter(i => !!i?.code) : []

    commit('setChecklists', onlyWithCode)
    commit('setTotal', total ?? 0)
    } catch ({ data }) {
      data?.errors?.length
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data?.message)
    } finally {
      commit('loading/setIsLoading', false, { root: true })
    }
  },

  async unlinkServiceType({ commit, dispatch }, id) {
    commit('setLoading', true)
    try {
      await unlinkAppointmentTypeChecklist(id)
      dispatch('fetchLinkedServiceTypes')
      dispatch('showSuccessMessage', Vue.i18n.translate('userChecklistModal.successfullyDeleted'))
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setLoading', false)
    }
  },

async loadAppointmentTypes({ commit, dispatch }, realEstateId = null) {
  commit('setIsLoading', true)
  try {
    const { data } = await fetchAppointmentTypes(realEstateId)
    const types = Array.isArray(data) ? data : []
    commit('setAppointmentTypes', types)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
    commit('setIsLoading', false)
  }
 },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
